import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import logo from "../assets/Logo.png";
import { useAuth } from "../context/authContext";
import { volverAClase } from "../utils/navigation";

export function ResumenEntreno() {
  const [entreno, setEntreno] = useState(null);
  const navigate = useNavigate();
  const { user } = useAuth();

  //Validar que estoy en resumenentreno
  useEffect(() => {
  localStorage.setItem("lastPage", "resumenentreno");
}, []);


  useEffect(() => {
    const entrenos = JSON.parse(localStorage.getItem("historialEntrenos") || "[]");
    if (entrenos.length > 0) {
      setEntreno(entrenos[entrenos.length - 1]); // último guardado
    }
  }, []);

  if (!entreno) {
    return (
      <div className="w-screen min-h-screen flex items-center justify-center bg-gradient-to-br from-gray-900 via-black to-gray-800 text-white">
        <p>No hay entrenos guardados aún.</p>
      </div>
    );
  }

  return (
    <div className="w-screen min-h-screen bg-gradient-to-br from-gray-900 via-black to-gray-800 flex flex-col items-center justify-center p-6 text-white">
      <motion.div
        initial={{ opacity: 0, scale: 0.9 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.6 }}
        className="bg-white/10 backdrop-blur-lg rounded-2xl shadow-xl w-[350px] p-6 text-center"
      >
        <h1 className="text-2xl font-bold text-green-400 mb-6">
          ✅ Entreno guardado
        </h1>

        <div className="space-y-3 text-lg">
          <p>📅 <span className="font-semibold">{entreno.fecha}</span></p>
          <p>⏱️ <span className="font-semibold">{entreno.duracion}</span></p>
          <p>🚴 <span className="font-semibold text-blue-400">{entreno.distancia}</span></p>
          <p>🔥 <span className="font-semibold text-orange-400">{entreno.calorias}</span></p>
          <p>⚡ <span className="font-semibold text-yellow-400">{entreno.cadenciaMedia} RPM</span></p>
          <p>🎉 <span className="font-semibold">{entreno.emojis}</span> emojis lanzados</p>
          <p>🏆 <span className="font-semibold text-green-400">{entreno.puntos}</span> puntos sesión</p>
          <p>
            🎯 <span className={`font-semibold ${entreno.modo === "Premium" ? "text-yellow-400" : "text-gray-300"}`}>
              {entreno.modo === "Premium" ? "Modo Premium" : "Modo Free"}
            </span>
          </p>

          {/* 👇 Nuevo */}
          {entreno.gimnasio && (
            <p>🏋️ <span className="font-semibold">{entreno.gimnasio}</span></p>
          )}
          {entreno.claseId && (
            <p>📌 Clase: <span className="font-semibold">{entreno.claseId}</span></p>
          )}

        </div>

        <div className="flex flex-col gap-3 mt-6">
          <button
            onClick={() => navigate("/historial")}
            className="bg-gradient-to-r from-blue-400 to-indigo-600 hover:from-blue-500 hover:to-indigo-700 text-white font-semibold py-3 rounded-xl shadow-lg transition"
          >
            Ver historial
          </button>
          <button
            onClick={() => volverAClase(navigate, user?.uid)}
            className="bg-gradient-to-r from-gray-600 to-gray-800 hover:from-gray-700 hover:to-black text-white font-semibold py-3 rounded-xl shadow-lg transition"
          >
            Volver
          </button>
        </div>

        <p className="mt-6 text-sm italic text-gray-300">
          Gran trabajo, cada pedalada cuenta 🚴🔥
        </p>
      </motion.div>
    </div>
  );
}

export default ResumenEntreno;
